import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useFieldAttributesQuery() {
  return useQuery({
    queryKey: ['fieldAttributes'],
    queryFn: async () => {
      const response = await axios.get(
        '/custom_fields/available_field_attributes',
      );

      return response.data;
    },
    select: (data) => formatData({ data, resourceTypes: ['fieldOption'] }),
  });
}
